import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Persist login state
        const savedUser = localStorage.getItem('sugarhut_user');
        if (savedUser) {
            let userObj = JSON.parse(savedUser);
            // Force values for mockup if it's the target email
            if (userObj.email === 'superbotboys@gmail.com') {
                userObj.role = 'admin';
                userObj.points = 42;
                userObj.name = 'Super Bot Boys';
            }
            setUser(userObj);
        }
        setLoading(false);
    }, []);

    const login = (email, password) => {
        // Mock login
        if (email && password) {
            const mockUser = {
                id: '1',
                name: 'Super Bot Boys',
                email: email,
                role: (email === 'admin@sugarhut.com' || email === 'superbotboys@gmail.com') ? 'admin' : 'user',
                points: 42
            };
            setUser(mockUser);
            localStorage.setItem('sugarhut_user', JSON.stringify(mockUser));
            return true;
        }
        return false;
    };

    const signup = (name, email, password) => {
        // Mock signup
        if (name && email && password) {
            const mockUser = {
                id: '2',
                name: name,
                email: email,
                role: 'user',
                points: 0
            };
            setUser(mockUser);
            localStorage.setItem('sugarhut_user', JSON.stringify(mockUser));
            return true;
        }
        return false;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('sugarhut_user');
    };

    return (
        <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
